// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.s84vHdvXUJLQdS {
  background-color: var(--ds-background-neutral, #091e420f);
  flex-shrink: 0;
  min-height: 20px;
  border-radius: 8px;
  box-shadow: none;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"dropPreview": `s84vHdvXUJLQdS`
};
export default ___CSS_LOADER_EXPORT___;
